/* src/app/components/discovery/review-sets/review-sets.component.scss */
.inactive-row {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #FFFFFF;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  border-left: 2px solid #223F92;
}
.inactive-row .row-content {
  padding: 20px 21px;
}
.active-row {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #FFFAED;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
  border-left: 2px solid #223F92;
}
.active-row .row-content {
  padding: 20px 21px;
}
.disabled-row {
  opacity: 0.5;
  background-color: #f3f3f3;
}
.disable-events {
  pointer-events: none;
}
.admin-actions {
  display: flex;
}
.disabled-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}
.fa-stop,
.fa-circle-stop {
  color: #bc2121;
}
.fa-edit,
.fa-trash,
.fa-file-dashed-line {
  color: #3f51b5;
}
.fa-play,
.fa-check,
.fa-circle-play {
  color: #2B9222;
}
:host-context(.dark-theme) .disabled-icon {
  color: rgba(255, 255, 255, 0.3) !important;
}
:host-context(.dark-theme) .fa-stop,
:host-context(.dark-theme) .fa-circle-stop {
  color: #df473c;
}
:host-context(.dark-theme) .fa-edit,
:host-context(.dark-theme) .fa-trash,
:host-context(.dark-theme) .fa-file-dashed-line {
  color: #6b80c9;
}
:host-context(.dark-theme) .fa-play,
:host-context(.dark-theme) .fa-check,
:host-context(.dark-theme) .fa-circle-play {
  color: #45b549;
}
:host-context(.dark-theme) .disabled-row {
  background-color: #717171;
}
tr.mat-row {
  position: relative;
  z-index: 0;
}
table.mat-mdc-table th[mat-header-cell],
table.mat-mdc-table td[mat-cell] {
  white-space: nowrap;
  padding: 0;
}
table[mat-table] td[mat-cell] {
  font-size: 14px;
}
/*# sourceMappingURL=review-sets.component.css.map */
